import React from "react";
import { useFQuickAccessList } from "./hooks/useFQuickAccessListr";
import styles from "./style/FQuickAccessList.module.scss";
import { MailIcon, PhoneIcon } from "@heroicons/react/solid";

const FQuickAccessList = ({
  productsShortcuts = [],
  btn = true,
  containerTitle = "",
  action=()=>{}
}) => {
  return (
    <>
      {productsShortcuts.map((category) => (
        <section
          class="flex-shrink-0 rounded-3xl cursor-pointer shadow-lg mt-5 border-2"
          onClick={()=>{action(category)}}
        >
          <div className="flex-1 flex flex-col p-2">
            <div className="w-20 h-20 sm:w-32 sm:h-32 flex-shrink-0 mx-auto rounded-full flex place-content-center items-center">
              <img
                src={category.iconUrl}
                className="w-28 sm:w-28 rounded-2xl"
              />
            </div>
            <h3 className="mt-2 text-gray-900 text-xs sm:text-sm font-medium flex place-content-center items-center">
              {category.product.description}
            </h3>
            <h3 className="mt-2 text-gray-900 text-xs sm:text-sm font-medium flex place-content-center items-center">
              {btn ? (
                <button className="bg-primary px-4 sm:w-28 py-1 rounded-3xl text-white hover:shadow-lg hover:shadow-primary/50">
                  {"ver más"}
                </button>
              ) : (
                <div className="bg-gray-200 p-2 rounded-xl">{category.km}</div>
              )}
            </h3>
          </div>
        </section>
      ))}
    </>
  );
};

export default FQuickAccessList;
